/**
 * Generate a URL-friendly slug from a title
 * @param title - The form title to convert to a slug
 * @param addUniqueSuffix - Whether to add a unique suffix for uniqueness
 * @returns A URL-friendly slug
 */
export const generateSlugFromTitle = (title: string, addUniqueSuffix: boolean = true): string => {
  if (!title || title.trim() === '') {
    throw new Error('Title cannot be empty');
  }

  // Generate base slug from title
  let slug = title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
    .substring(0, 50); // Limit length

  // Add unique suffix if requested
  if (addUniqueSuffix) {
    const uniqueId = Math.random().toString(36).substring(2, 10);
    slug = `${slug}-${uniqueId}`;
  }

  return slug;
};

/**
 * Validate if a slug is valid
 * @param slug - The slug to validate
 * @returns True if valid, false otherwise
 */
export const isValidSlug = (slug: string): boolean => {
  if (!slug || slug.trim() === '') {
    return false;
  }

  // Slug should only contain lowercase letters, numbers, and hyphens
  const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  return slugRegex.test(slug);
};
